import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import SimpleTreeControlView, {
    ITreeNode
} from '@techsee/techsee-ui-common/lib/simple-tree-control-view/SimpleTreeControlView';
import {ITreeController} from '../../../contract';
import {LibraryTreeTemplate} from './LibraryTree.template';

interface LibraryTreeProps {
    ctrl: ITreeController;
}

const ObserverTree = observer(SimpleTreeControlView);

@observer
export class LibraryTree extends TechseeBaseComponent<LibraryTreeProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        if (ctrl.empty) {
            return <></>;
        }

        return (
            <ObserverTree
                className='tree-dark'
                style={{overflowX: 'hidden'}}
                data={ctrl.treeData as ITreeNode}
                onNodeExpandCollapseClick={ctrl.expandCollapse}
                onNodeSelectClick={ctrl.selectNode}
                templateComponent={LibraryTreeTemplate}
                options={{startDepth: 1}}
            />
        );
    }
}
